import { getAccessTokenSilently } from "utils/functions";
import Grid from "@material-ui/core/Grid";
import FilterListIcon from "@material-ui/icons/FilterList";
import { DatePickerField } from "_metronic/_partials/controls";
import { ReactComponent as FilterIcon } from "assets/icons/filter-icon.svg";
import BottomArrowSvg from "assets/icons/svg/BottomArrowSvg";
import CrossSvg from "assets/icons/svg/cross";
import { InputField, LabelField, SelectField } from "components";
import Button from "components/button/Button";
import FilterTabs from "components/filterTabs/FilterTabs";
import { MenuMultiCheckBox } from "components/MenuMultiCheckBox/MenuMultiCheckBox";
import MyButton from "components/MyButton";
import SearchComp from "components/Searchcomponent";
import { useFormik } from "formik";
import { getDateFormat, getDateFormatForDatePicket } from "helper/dateFormat";
import { getCurrency } from "helper/numberFormat";
import { useSearch } from "hook";
import React, { useEffect, useState } from "react";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { toastr } from "react-redux-toastr";
import { Link } from "react-router-dom";
import Select, { components } from "react-select";
import DateRangePicker from "rsuite/DateRangePicker";
import "rsuite/dist/rsuite.min.css";
import FinanceService from "../../Lib/API/Finance";
import { Fonts, FontWeights, FontColors } from "theme/fontConfig";

const selectControlStyles = {
  backgroundColor: "#FFFFFF",
  borderColor: "#FFFFFF",
  color: FontColors.GrayB5B5C3,
  transition:
    "color 0.15s ease, background-color 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease",
  paddingTop: "6px",
  paddingBottom: "6px",
  cursor: "pointer",
};
const colourStyles = {
  control: (styles) => ({
    ...styles,
    ...selectControlStyles,
  }),
};

const formatOptionLabel = ({ label, _id }) => {
  return (
    <div className="dropdown-container" key={_id}>
      <div className="icon-name-container d-flex align-items-center justify-content-start">
        <div className="name-container" style={{ marginInlineStart: 10 }}>
          <div>{label}</div>
        </div>
      </div>
    </div>
  );
};

export const FinanceFilter = ({
  filter,
  onSearchChange,
  onChargeDateChange,
  onLedgerAccountChange,
  onPaidDateChange,
  onAmountChange,
  onChargedStatusChange,
  onPaymentStatusChange,
  onOverdueDaysChange,
  onClear,
  onStatusChange,
  setTabClick,
  setFilters,
  initialFilters,
  toggle,
  setDateRange,
  setPaidRange,
  startDate,
  startPaidDate,
  endPaidDate,
  endDate,
  onFieldChange,
  onFilterGoClicked,
  setGoSetting,
  goSetting,
}) => {
  const regex = /([0-9]*[\.|\,]{0,1}[0-9]{0,1})/s;
  const { searchAction } = useSearch({ action: setOnSearch });
  const isMobile = useMediaQuery("(max-width:600px)");

  const [openFilter, setOpenFilter] = useState(false);
  const [ledgers, setLedgers] = useState(false);
  const [loading, setLoading] = useState(false);
  const [onSearch, setOnSearch] = useState("");
  const [date, setDate] = useState([]);
  const [pdDate, setPdDate] = useState([]);

  const currency = getCurrency();
  const placeholderFormat = getDateFormat();
  const dateFormat = getDateFormatForDatePicket();

  const validate = (values) => {
    const errors = {};
    if (
      (values?.id?.length > 24 || values?.id?.length < 24) &&
      values?.id?.length !== 0
    ) {
      errors.id = "Id must be 24 characters";
    }

    return errors;
  };

  const formik = useFormik({
    isInitialValid: false,
    enableReinitialize: true,
    initialValues: { all_ledger_sub_data: [], ledger: [], subLedger: [] },
    validate,
    onSubmit: async (values) => {},
  });
  const exceptThisSymbols = ["e", "E", "+", "-"];

  const preventArrows = (e) => {
    if (e.which === 38 || e.which === 40 || exceptThisSymbols.includes(e.key))
      e.preventDefault();
  };

  useEffect(() => {
    if (endDate < startDate) {
      toastr.error("End Date should be greater than start date.");
      setDateRange([null, null]);
      setDate([]);
    }
  }, [endDate]);

  useEffect(() => {
    if (endPaidDate < startPaidDate) {
      toastr.error("End Date should be greater than start date.");
      setPaidRange([null, null]);
      setPdDate([]);
    }
  }, [endPaidDate]);

  useEffect(() => {
    onChargeDateChange(formik.values?.charged_date);
    onPaidDateChange(formik.values?.paid_at);
    onFieldChange("ledger", formik.values?.ledger);
    onAmountChange(formik.values?.amount);
    onFieldChange("subLedger", formik.values?.subLedger);
    // eslint-disable-next-line
  }, [formik.values]);
  useEffect(() => {
    async function getLedgeraccounts() {
      setLoading(true);
      const token = await getAccessTokenSilently();
      const res = await FinanceService.getLedgerSubLedgerList(token);
      if (res?.ledgers) {
        const arrayWithSelectAll = ["Select All", ...res?.ledgers];
        setLedgers(arrayWithSelectAll);
        setLoading(false);
      }
    }
    getLedgeraccounts();
  }, [getAccessTokenSilently]);

  const onFilterClear = () => {
    formik.setFieldValue("charged_date", undefined);
    formik.setFieldValue("ledger", []);
    formik.setFieldValue("subLedger", []);
    formik.setFieldValue("all_ledger_sub_data", []);
    formik.setFieldValue("paid_at", undefined);
    formik.setFieldValue("amount", "");
    setDateRange([null, null]);
    setPaidRange([null, null]);
    setDate([]);
    setPdDate([]);
    onClear();
    setGoSetting(true);
  };

  const options =
    ledgers &&
    ledgers?.map((item) => {
      return {
        label: item.ledger_name,
        value: item._id,
      };
    });

  const DropdownIndicator = (props) => {
    return (
      <components.DropdownIndicator {...props}>
        <BottomArrowSvg label="Emoji" />
      </components.DropdownIndicator>
    );
  };
  const filterTabs = [
    {
      title: "Open",
      value: "open",
    },
    {
      title: "Closed",
      value: "closed",
    },
  ];
  useEffect(() => {
    if (toggle === "Transaction") {
      setFilters(initialFilters);
    }
  }, [toggle]);

  const isFiltered =
    !!filter?.search ||
    !!filter?.filter?.charge_date ||
    !!filter?.filter?.paid_at ||
    !!(filter?.filter?.ledger?.length) ||
    !!(filter?.filter?.subLedger?.length) ||
    !!filter?.filter?.amount;

  const statusToggle = (
    <div style={{ display: "inline-flex", alignItems: "center", background: "#fff", border: "1px solid #CBD5E1", borderRadius: 32, padding: 3, gap: 2, height: 34, boxSizing: "border-box" }}>
      {filterTabs.map((tab) => {
        const chargeStatus = filter?.filter?.charge_status;
        const isActive = tab.value === (
          (Array.isArray(chargeStatus) ? chargeStatus.includes("closed") : chargeStatus === "closed") ? "closed" : "open"
        );
        return (
          <button
            key={tab.value}
            onClick={() => onStatusChange(tab.value)}
            style={{
              padding: "0 18px", height: 28, borderRadius: 28, border: "none",
              backgroundColor: isActive ? "#2555EF" : "transparent",
              color: isActive ? "#FFFFFF" : "#64748B",
              fontWeight: isActive ? FontWeights.Bold : FontWeights.Medium, fontSize: Fonts.GeneralButtonFont.fontSize,
              fontFamily: Fonts.GeneralButtonFont.fontFamily, cursor: "pointer", whiteSpace: "nowrap",
              boxShadow: isActive ? "0 1px 4px rgba(37,85,239,0.25)" : "none",
              transition: "all 0.15s ease",
            }}
          >
            {tab.title}
          </button>
        );
      })}
    </div>
  );

  return (
    <div className="filteration">
      <div className="activated-ledger d-flex flex-column flex-lg-row justify-content-between align-items-lg-center mb-5 w-100">
        <div className="sub-header-functions" style={isMobile ? { flexDirection: "column", alignItems: "stretch", gap: 8 } : {}}>
          {isMobile ? (
            <>
              <span className="finance-filter-serach-bar" style={{ width: "100%" }}>
                <SearchComp
                  value={filter?.search ? filter?.search : ""}
                  setSearchText={onSearchChange}
                  placeholder="Search by ledger account or amount"
                />
              </span>
              <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                <Button
                  variant="filter"
                  onClick={() => setOpenFilter(!openFilter)}
                  style={{ height: 34, borderRadius: 32, padding: "0 18px", ...(openFilter ? { opacity: 0.3 } : {}) }}
                  size="md"
                >
                  <FilterIcon />
                  <span>Filter</span>
                </Button>
                {statusToggle}
                {isFiltered && !openFilter && (
                  <span style={{ display: "inline-flex", alignItems: "center", gap: 6, backgroundColor: "#EEF2FF", color: FontColors.Blue2555EF, border: "1px solid #C7D2FE", borderRadius: 20, padding: "3px 12px", ...Fonts.GeneralSmallLabelFont, whiteSpace: "nowrap" }}>
                    <span style={{ width: 7, height: 7, borderRadius: "50%", backgroundColor: "#2555EF", display: "inline-block" }} />
                    Filters active
                    <span onClick={onFilterClear} style={{ cursor: "pointer", marginLeft: 4, fontSize: Fonts.GeneralBodyFont.fontSize, lineHeight: 1, color: FontColors.Blue6366F1 }} title="Clear filters">×</span>
                  </span>
                )}
              </div>
            </>
          ) : (
            <>
              <span className="finance-filter-serach-bar">
                <SearchComp
                  value={filter?.search ? filter?.search : ""}
                  setSearchText={onSearchChange}
                  placeholder="Search by ledger account or amount"
                />
              </span>
              <div className="pl-5" style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap" }}>
                <Button
                  variant="filter"
                  onClick={() => setOpenFilter(!openFilter)}
                  style={{ height: 34, borderRadius: 32, padding: "0 18px", ...(openFilter ? { opacity: 0.3 } : {}) }}
                  size="md"
                >
                  <FilterIcon />
                  <span>Filter</span>
                </Button>
                {statusToggle}
                {isFiltered && !openFilter && (
                  <span style={{ display: "inline-flex", alignItems: "center", gap: 6, backgroundColor: "#EEF2FF", color: FontColors.Blue2555EF, border: "1px solid #C7D2FE", borderRadius: 20, padding: "3px 12px", ...Fonts.GeneralSmallLabelFont, whiteSpace: "nowrap" }}>
                    <span style={{ width: 7, height: 7, borderRadius: "50%", backgroundColor: "#2555EF", display: "inline-block" }} />
                    Filters active
                    <span onClick={onFilterClear} style={{ cursor: "pointer", marginLeft: 4, fontSize: Fonts.GeneralBodyFont.fontSize, lineHeight: 1, color: FontColors.Blue6366F1 }} title="Clear filters">×</span>
                  </span>
                )}
              </div>
            </>
          )}
        </div>
      </div>
      {openFilter && (
        <div className="filter mb-10">
          <Link></Link>
          <div className=" text-right px-5 pt-5">
            <span
              className="cursor-pointer"
              onClick={() => setOpenFilter(false)}
            >
              <CrossSvg />
            </span>
          </div>
          <div className="filter-wrapper">
            <Grid container spacing={5}>
              <Grid item xs={12} sm={6} md={3}>
                <LabelField title={"Charged Date"} />
                <DateRangePicker
                  format={dateFormat}
                  placeholder={`${placeholderFormat}  ~  ${placeholderFormat}`}
                  cleanable={false}
                  editable={false}
                  onKeyPress={(event) => {
                    if (!/[0-9]/.test(event.key)) {
                      event.preventDefault();
                    }
                  }}
                  style={{
                    display: "inline-block",
                    padding: "0",
                    border: "0",
                    width: "100%",
                    color: FontColors.Black,
                  }}
                  size="lg"
                  value={date}
                  onChange={(update) => {
                    setDateRange(update);
                    setDate(update);
                    formik.setFieldValue("charged_date", update);
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <LabelField title={"Paid Date"} />
                <DateRangePicker
                  format={dateFormat}
                  placeholder={`${placeholderFormat}  ~  ${placeholderFormat}`}
                  onKeyPress={(event) => {
                    if (!/[0-9]/.test(event.key)) {
                      event.preventDefault();
                    }
                  }}
                  cleanable={false}
                  editable={false}
                  style={{
                    display: "inline-block",
                    padding: "0",
                    border: "0",
                    width: "100%",
                    color: FontColors.Black,
                  }}
                  size="lg"
                  value={pdDate}
                  onChange={(update) => {
                    setPaidRange(update);
                    setPdDate(update);
                    formik.setFieldValue("paid_at", update);
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <LabelField title={"Ledger Account"} />
                <MenuMultiCheckBox
                  Items={ledgers}
                  formik={formik}
                  loading={loading}
                  isLedger={true}
                  field="all_ledger_sub_data"
                  withBorder={true}
                  width={"100%"}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <InputField
                  type="number"
                  {...{
                    formik,
                    title: "Amount",
                    name: "amount",
                    placeholderIcon: (
                      <span className="filter-amount-placeholder">
                        {currency}
                      </span>
                    ),
                    placeholder: "Amount",
                    value: formik.values?.amount,
                  }}
                  onKeyDown={(e) => preventArrows(e)}
                  min="0"
                  onChange={(e) => {
                    formik.setFieldValue(
                      `amount`,
                      e.target.value.match(regex)[0]
                    );
                  }}
                />
              </Grid>
            </Grid>
          </div>
          <div className="pr-12 pl-9 pb-10 justify-content-end d-flex">
            <Button
              variant="primary-outline"
              size="md"
              onClick={onFilterClear}
              style={{ marginRight: 10, minWidth: 80 }}
            >
              Clear
            </Button>
            <Button
              variant="primary"
              size="md"
              style={{ minWidth: 80 }}
              onClick={() => {
                setOpenFilter(false);
                onFilterGoClicked();
              }}
            >
              Go
            </Button>
          </div>
        </div>
      )}
    </div>
  );
};
